import { apiRoot } from "../../../../old/beheer/store/api/apiRoot";

const piggyRewardsEndpoints = apiRoot.enhanceEndpoints({
  addTagTypes: ["PiggyRewards"],
});

export type ApiPiggyReward = {
  id: number;
  is_active: boolean;
  jamezzPiggyReward: JamezzPiggyReward | null;
  media: {
    id: string;
    type: string;
    value: string;
  };
  pre_redeemable: boolean;
  required_credits: number;
  reward_type: string;
  stock: null;
  title: string;
  type: string;
  uuid: string;
};

export type JamezzPiggyReward = {
  id: number;
  rewardable_type: string;
  rewardable_id: number;
};

export const piggyRewardsApi = piggyRewardsEndpoints.injectEndpoints({
  endpoints: (builder) => ({
    getPiggyRewards: builder.query<{ apiPiggyRewards: ApiPiggyReward[] }, { salesAreaId: number }>({
      query: ({ salesAreaId }) => {
        return {
          url: `/piggy-rewards?salesAreaId=${salesAreaId}`,
          method: "GET",
        };
      },
      providesTags: (result) =>
        result
          ? [
              ...result.apiPiggyRewards.map(({ id }) => ({ type: "PiggyRewards" as const, id })),
              { type: "PiggyRewards" },
            ]
          : [{ type: "PiggyRewards" }],
    }),
    updateOrCreatePiggyReward: builder.mutation<
      any,
      {
        vestiging_id: number;
        piggy_id: number;
        piggy_uuid: string;
        rewardable_type: string | null;
        rewardable_id: number | null;
      }
    >({
      invalidatesTags: ["PiggyRewards"],
      query: (body) => {
        return {
          url: `/piggy-rewards/update-or-create`,
          method: "POST",
          body,
        };
      },
    }),
  }),
});

export const { useGetPiggyRewardsQuery, useUpdateOrCreatePiggyRewardMutation } = piggyRewardsApi;
